shadow$provide[396] = function(global,require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, createCollection:{enumerable:true, get:function() {
  return createCollection;
}}, default:{enumerable:true, get:function() {
  return $$default;
}}, unstable_createCollection:{enumerable:true, get:function() {
  return unstable_createCollection;
}}});
var React = require("react");
var require$_CIRCA_radix_ui_SLASH_react_context = require("@radix-ui/react-context");
var require$_CIRCA_radix_ui_SLASH_react_compose_refs = require("@radix-ui/react-compose-refs");
var require$_CIRCA_radix_ui_SLASH_react_slot = require("@radix-ui/react-slot");
function createCollection(name) {
  const PROVIDER_NAME = name + "CollectionProvider";
  const [createCollectionContext, createCollectionScope] = (0,require$_CIRCA_radix_ui_SLASH_react_context.createContextScope)(PROVIDER_NAME);
  const [CollectionProviderImpl, useCollectionContext] = createCollectionContext(PROVIDER_NAME, {collectionRef:{current:null}, itemMap:new Map(),});
  const CollectionProvider = props => {
    const {scope, children} = props;
    const ref = React.useRef(null);
    const itemMap = React.useRef(new Map()).current;
    return React.createElement(CollectionProviderImpl, {scope, itemMap, collectionRef:ref, children,});
  };
  CollectionProvider.displayName = PROVIDER_NAME;
  const COLLECTION_SLOT_NAME = name + "CollectionSlot";
  const CollectionSlotImpl = (0,require$_CIRCA_radix_ui_SLASH_react_slot.createSlot)(COLLECTION_SLOT_NAME);
  const CollectionSlot = React.forwardRef((props, forwardedRef) => {
    const {scope, children} = props;
    const context = useCollectionContext(COLLECTION_SLOT_NAME, scope);
    const composedRefs = (0,require$_CIRCA_radix_ui_SLASH_react_compose_refs.useComposedRefs)(forwardedRef, context.collectionRef);
    return React.createElement(CollectionSlotImpl, {ref:composedRefs, children,});
  });
  CollectionSlot.displayName = COLLECTION_SLOT_NAME;
  const ITEM_SLOT_NAME = name + "CollectionItemSlot";
  const ITEM_DATA_ATTR = "data-radix-collection-item";
  const CollectionItemSlotImpl = (0,require$_CIRCA_radix_ui_SLASH_react_slot.createSlot)(ITEM_SLOT_NAME);
  const CollectionItemSlot = React.forwardRef((props, forwardedRef) => {
    const {scope, children, ...itemData} = props;
    const ref = React.useRef(null);
    const composedRefs = (0,require$_CIRCA_radix_ui_SLASH_react_compose_refs.useComposedRefs)(forwardedRef, ref);
    const context = useCollectionContext(ITEM_SLOT_NAME, scope);
    React.useEffect(() => {
      context.itemMap.set(ref, {ref, ...itemData});
      return () => void context.itemMap.delete(ref);
    });
    const extraProps = {};
    extraProps[ITEM_DATA_ATTR] = "";
    return React.createElement(CollectionItemSlotImpl, {...extraProps, ref:composedRefs, children,});
  });
  CollectionItemSlot.displayName = ITEM_SLOT_NAME;
  function useCollection(scope) {
    const context = useCollectionContext(name + "CollectionConsumer", scope);
    const getItems = React.useCallback(() => {
      const collectionNode = context.collectionRef.current;
      if (!collectionNode) {
        return [];
      }
      const orderedNodes = Array.from(collectionNode.querySelectorAll(`[${ITEM_DATA_ATTR}]`),);
      const items = Array.from(context.itemMap.values());
      const orderedItems = items.sort((a, b) => orderedNodes.indexOf(a.ref.current) - orderedNodes.indexOf(b.ref.current),);
      return orderedItems;
    }, [context.collectionRef, context.itemMap]);
    return getItems;
  }
  return [{Provider:CollectionProvider, Slot:CollectionSlot, ItemSlot:CollectionItemSlot,}, useCollection, createCollectionScope,];
}
const unstable_createCollection = createCollection;
const $$default = createCollection;

};